import { Button, cn } from '@longy/web-components'
import { CalendarPlus } from 'lucide-react'
import { useTranslation } from 'react-i18next'

type BookingCtaButtonProps = {
    onClick: () => void
    className?: string
}

export const BookingCtaButton = ({ onClick, className }: BookingCtaButtonProps) => {
    const { t } = useTranslation()

    return (
        <Button className={cn('gap-2 rounded-full px-5', className)} size="sm" onClick={onClick}>
            <CalendarPlus className="size-4" />
            {t('frontend.header.bookAppointment')}
        </Button>
    )
}
